import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function ExploreSection() {
  const randomVideos = videos.sort(() => 0.5 - Math.random()).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100">
              <i className="ri-compass-3-line text-accent-600 text-lg"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900">发现更多</h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {randomVideos.map((video) => (
            <Link
              key={video.id}
              to={`/video/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 91视频网站最新内容`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/70 text-white text-xs">
                  {video.duration}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {video.rating}
                  </span>
                  <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">{video.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}